import React from 'react'
import SmallIconEnum from '../../../models/small-icon-enum'
import IconColorEnum from '../../../models/icon-color-enum'

interface Props {
    icon: SmallIconEnum
    color?: IconColorEnum
}

export default function SmallIcons({
    icon,
    color = IconColorEnum.GrayColor,
}: Props): JSX.Element {
    switch (icon) {
        case SmallIconEnum.GallenteIcon:
            return (
                <svg
                    width="17"
                    height="16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M13.755 5.917C14.607 7.69 16.25 7.67 16.25 7.67c-2.172-2.535-2.212-3.596-2.212-3.596.477.902 2.055.564 2.055.564-1.406-.651-1.829-1.737-1.829-1.737 1.28.191 1.775-.726 1.775-.726-1.072.239-2.073-.45-2.073-.45C15.644 1.496 15.308.25 15.308.25c-.03.442-1.37.708-2.508.435-1.213-.293-1.344.5-1.344.5-.259 1.247 1.635 1.26.723 2.79-.825 1.385-1.909.846-1.909.846-.206-.137-1.633-.78-.636-2.16.206-.288.03-.882.03-.882.614-.03.81-.54.81-.54-.947.353-1.188.028-1.188.028-.39-.428-.853-.689-.853-.689C8.036.337 7.93.712 7.171.451 6.684.285 6.129.715 6.129.715c.485-.214.905.355 1.024.455 0 0-.188.763.56 1.058.596.236.937.555.36.86-.997.53-.875 1.273-1.173 1.608-.221.249-.689.269-.689.269s-1.043.12-1.632-.984c-.858-1.61 1.103-1.365.713-2.834 0 0-.157-.862-1.335-.457-1.238.42-2.48.002-2.51-.44 0 0-.256 1.28 1.34 1.479 0 0-1 .688-2.07.45 0 0 .337.773 1.774.725 0 0-.269 1.126-1.675 1.777 0 0 1.51.2 1.898-.603 0 0-.002 1.06-2.214 3.596 0 0 1.958-.333 2.635-1.63 0 0 .579 1.431-2.434 4.769 0 0 3.368-1.225 3.542-3.639 0 0 .606 1.472-.592 4.04 0 0 1.676-1.035 1.88-2.516 0 0 .536.258.375 1.208 0 0 .594-.246.614-1.569 0 0 .648.585.248 1.45 0 0-.455.738-.574.85-.117.111-.087.268.008.32l-.985 1.504s-.107-.343-.455-.48c-.536-.211-.88.256-.88.256s.557-.365.83.184c0 0-.874-.298-1.242.73 0 0 .567-.705 1.126-.3 0 0-.388.616-.174 1.471 0 0 .293-1.389.865-1.36 0 0 .4 0 .256 1.035 0 0 .579-1.17-.104-1.38l1.29-1.292c.057.02.427.142.494-.1.29-1.03.472-1.11.472-1.11-1.188 3.484-.33 4.58-.333 4.585.028-.074.206-.924.448-1.238 0 0 .124 1.477.586 2.486.522-1.084.592-2.56.592-2.56.082.136.325 1.034.385 1.367 0 0 .912-1.223-.365-4.64 0 0 .268.315.509 1.11.08.259.502.098.502.098l1.412 1.369c-.798.358-.283 1.486-.283 1.486 0-1.031.392-1.031.392-1.031.57-.03.87 1.265.87 1.265.214-.853-.174-1.472-.174-1.472.56-.405 1.156.341 1.156.341-.405-1.18-1.273-.77-1.273-.77.239-.433.748-.217.748-.217s-.397-.286-.735-.159c-.39.147-.465.435-.465.435s-1.225-1.563-1.128-1.615c.099-.053.129-.21.01-.323-.117-.112-.575-.85-.575-.85-.4-.868.14-1.502.14-1.502-.102.982.598 1.437.598 1.437-.05-1.014.21-1.476.21-1.476.402 2.323 2.176 2.94 2.176 2.94-1.026-2.548-.763-4.039-.763-4.039.495 2.364 3.661 3.69 3.661 3.69-2.828-3.18-2.241-4.915-2.241-4.915ZM8.39 1.137a.257.257 0 0 1-.221.052c-.104-.027-.122-.144-.124-.2-.15-.04-.289-.033-.398.051 0 0 .365-.328.76-.022.518.395.677.907.677.907s-.224-.507-.694-.788Z"
                        fill={color}
                    />
                </svg>
            )
        case SmallIconEnum.MinmatarIcon:
            return (
                <svg
                    width="17"
                    height="17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M3.505 14.544a5.436 5.436 0 0 1-.433-1.61l-1.73.05a8.564 8.564 0 0 0 3.967 3.978 6.905 6.905 0 0 1-1.804-2.418ZM12.053 16.388c2.811-1.106 4.784-3.644 4.938-6.868a7.895 7.895 0 0 0-3.479-6.933L10.29 8.75l-.455-.276a3.134 3.134 0 0 0-2.88-.183 4.01 4.01 0 0 0-2.132 2.233 4.012 4.012 0 0 0 .072 3.085c.577 1.308 1.677 2.477 3.115 2.912 1.365.413 2.82.348 4.043-.133ZM4.636 8.5a5.425 5.425 0 0 1 1.647-1.125c.134-.06.27-.11.408-.157L4.899 1.82a8.554 8.554 0 0 0-3.77 4.253L4.635 8.5ZM3.063 11.85a5.473 5.473 0 0 1 .885-2.508L.772 7.144a8.544 8.544 0 0 0 .142 4.77l2.15-.063Z"
                        fill={color}
                    />
                    <path
                        d="M7.763 7.008c.719-.05 1.446.071 2.115.365l2.987-5.715a8.521 8.521 0 0 0-6.98-.305l1.878 5.655Z"
                        fill={color}
                    />
                </svg>
            )
        case SmallIconEnum.AmarrIcon:
            return (
                <svg
                    width="19"
                    height="13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M6.174 5.354a11.377 11.377 0 0 1 3.718-.605c1.343 0 2.607.22 3.717.605.575-.42 1.031-.936 1.324-1.516-1.435-.644-3.17-1.023-5.041-1.023-1.872 0-3.608.379-5.043 1.023.294.58.75 1.096 1.325 1.516ZM.961 8.67c0 1.283.629 2.467 1.694 3.431-.452-.654-.706-1.38-.706-2.146 0-1.029.458-1.986 1.243-2.794a6.133 6.133 0 0 1-.885-1.579C1.456 6.478.961 7.536.961 8.671ZM17.477 5.582a6.132 6.132 0 0 1-.885 1.58c.785.807 1.242 1.765 1.242 2.793 0 .766-.253 1.492-.706 2.146 1.065-.964 1.695-2.148 1.695-3.43 0-1.135-.495-2.193-1.346-3.089Z"
                        fill={color}
                    />
                    <path
                        d="M15.59.162c.355.654.555 1.38.555 2.146 0 2.876-2.8 5.207-6.252 5.207-3.454 0-6.253-2.33-6.253-5.207 0-.765.2-1.492.555-2.146-.838.965-1.334 2.15-1.334 3.431 0 2.79 2.345 5.123 5.482 5.711h-.014c.027 0 .054.008.08.013l.077.014c.74.245 1.407 2.125 1.407 2.125s.615-1.872 1.392-2.123l.111-.02c.02-.003.04-.01.06-.01h-.014c3.137-.587 5.482-2.92 5.482-5.71 0-1.282-.497-2.467-1.334-3.43Z"
                        fill={color}
                    />
                </svg>
            )
        case SmallIconEnum.CaldariIcon:
            return (
                <svg
                    width="16"
                    height="16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M8 0C3.589 0 0 3.588 0 8c0 4.411 3.59 8 8 8 4.412 0 8-3.589 8-8 0-4.412-3.588-8-8-8ZM6.116 6.926a2.169 2.169 0 1 1 0 2.147l-1.773.44a3.957 3.957 0 0 0 7.046.53l1.644.41A5.605 5.605 0 0 1 8 13.6 5.606 5.606 0 0 1 2.4 8C2.4 4.913 4.91 2.4 8 2.4a5.605 5.605 0 0 1 5.033 3.148l-1.644.409a3.958 3.958 0 0 0-7.046.531l1.773.438Z"
                        fill={color}
                    />
                </svg>
            )
        case SmallIconEnum.OreIcon:
            return (
                <svg
                    width="20"
                    height="20"
                    viewBox="0 0 64 64"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect width="64" height="64" fill="url(#pattern0)" />
                    <defs>
                        <pattern
                            id="pattern0"
                            patternContentUnits="objectBoundingBox"
                            width="1"
                            height="1"
                        >
                            <use
                                xlinkHref="#image0_6:272"
                                transform="scale(0.015625)"
                            />
                        </pattern>
                        <image
                            id="image0_6:272"
                            width="64"
                            height="64"
                            xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAACD0lEQVR4nO2aOy8EURTHx661hIKEEI+ERCUKolKIjY7wFTSiIEqJD6JX+AwehUQ2UXvEigKFhBWvgkSw69n8T7I57J07E+5sMv9f88u4Z9w7e8/czNwzHiGEEEIIIYSQGFLld8nZbFZiUsot8BA8CPfCncpNcBquUV0V4QL8AF/AefgU3lO+g99KnclkvkzXlzA1xoFqi2ucgMfVcU+Z+E81Ex/Kr/CLOk8yTSalGW6Fh1W75hzHG8rrpotjBljErKljuUev4SdY7tVjWGbkBr6Hn2HJED2WelhnQDfcB3fBDXAbPK9sXOeYARYxck/LPbwKL8O5fxhXEPoROwvPwUmb/8EMCBD7Dm/DUc+8cARvwjNwnc3JzIAQ56QtYqKgFn36Pt2WwgyIoE95B2hUf3+EC55DmAEO+xqAZZVuV+1X8Aq872JQzACHfY3ACz5xJzAzwAX8ASpgDJHicg3YgeUtskO151WcE5gBDvs6gBdh/SQou8BFzyHMgAj6lBm+jaDvHzADQpzj9G0tAFJvMFaCNMyAELFjsOz/H/79sAIhu8JSudI1RyPMAIuYhPI0PAVXSmVIniukem0FM8AiZhL2qw7LdwGjcLnqsFSa9Gqtq8NJ5ZRq15SrDhthBljEyC+5BS/BYb8Qkf17vy9EZM24hGWNOYNlx2gX/vULET9inwGEEEIIIYQQQmKH53nfPWBh/s1BNr0AAAAASUVORK5CYII="
                        />
                    </defs>
                </svg>
            )
        case SmallIconEnum.CapsuleIcon:
            return (
                <svg
                    width="12"
                    height="13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M11.993 5.012 5.996 0 0 5.012v5.231l3.296 2.75 2.7-2.249 2.701 2.249 3.296-2.75v-5.23Zm-2.515 4.09-.81.67-2.7-2.25-2.672 2.25-.781-.656V6.183L5.996 3.27l3.482 2.912V9.1Z"
                        fill={color}
                    />
                </svg>
            )
        case SmallIconEnum.CorvetteIcon:
            return (
                <svg
                    width="16"
                    height="10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M8.003 0 0 6.887V10l8.003-6.887L16 10V6.887L8.003 0Z"
                        fill={color}
                    />
                </svg>
            )
        case SmallIconEnum.ShuttleIcon:
            return (
                <svg
                    width="16"
                    height="6"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M16.005 4.264H13.22L7.995 0 2.776 4.264H0V6H3.445l4.55-3.72L12.55 6h3.455V4.264Z"
                        fill={color}
                    />
                </svg>
            )
        case SmallIconEnum.FrigateIcon:
            return (
                <svg
                    width="16"
                    height="10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M16 6.894 8.01.007.02 6.894V10H16V6.894Zm-2.75.743H2.75l5.247-4.524 5.253 4.524Z"
                        fill={color}
                    />
                </svg>
            )
        case SmallIconEnum.DestroyerIcon:
            return (
                <svg
                    width="16"
                    height="13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M16 6.538 8.01 0 .02 6.538v2.956H16V6.538Zm-2.75.706H2.75l5.246-4.289 5.254 4.289ZM0 13h16v-2.25H0V13Z"
                        fill={color}
                    />
                </svg>
            )
        case SmallIconEnum.CruiserIcon:
            return (
                <svg
                    width="14"
                    height="14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M14 5.897 7.01 0 .018 5.897v8.086H14V5.897ZM2.04 11.973V6.838l4.957-4.175 4.958 4.175v5.135H2.04Z"
                        fill={color}
                    />
                </svg>
            )
        case SmallIconEnum.BattlecruiserIcon:
            return (
                <svg
                    width="12"
                    height="16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clipPath="url(#a)" fill={color}>
                        <path d="M12 5.495 6.008 0 .015 5.495v7.542H12V5.495ZM1.748 11.168V6.373l4.25-3.89 4.25 3.89v4.795h-8.5ZM0 16.005h12v-1.89H0v1.89Z" />
                    </g>
                </svg>
            )
        case SmallIconEnum.BattleshipIcon:
            return (
                <svg
                    width="14"
                    height="18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M13.994 5.883 7.006 0 .018 5.883v12.111l6.988-5.883 6.988 5.883V5.883Zm-2.044 7.74L6.994 9.459l-4.956 4.164v-6.8l4.956-4.164 4.956 4.164v6.8Z"
                        fill={color}
                    />
                </svg>
            )
        case SmallIconEnum.CarrierIcon:
            return (
                <svg
                    width="14"
                    height="16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M6.984.889 0 6.324v3.352l7.002 5.435L14 9.676V6.324L6.984.89ZM1.546 9.014V6.982l5.438-4.224 5.457 4.228v2.032l-5.439 4.224-5.456-4.228Z"
                        fill={color}
                    />
                </svg>
            )
        case SmallIconEnum.DreadnoughtIcon:
            return (
                <svg
                    width="14"
                    height="14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M14 6.06 7.002 0 .008 6.057v4.472h2.996l4.006 3.467 4.002-3.467h2.996L14 6.061ZM10.49 9.119l-3.49 3.024-3.488-3.02h-2.13V6.708l5.619-4.862 5.622 4.87V9.13l-2.133-.012Z"
                        fill={color}
                    />
                </svg>
            )
        case SmallIconEnum.TitanIcon:
            return (
                <svg
                    width="12"
                    height="20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clipPath="url(#a)" fill={color}>
                        <path d="M11.995 5.295 6.005 0 .015 5.295v6.4l5.99-5.3 5.99 5.3v-6.4Zm-1.752 2.46L5.995 4.002 1.747 7.755v-1.61l4.248-3.752 4.248 3.748v1.614Z" />
                        <path d="m11.995 13.605-5.99-5.3-5.99 5.3V20l5.99-5.295L11.995 20v-6.395Zm-1.752 2.455-4.248-3.747-4.248 3.747v-1.609l4.248-3.753 4.248 3.753v1.61Z" />
                    </g>
                </svg>
            )
        case SmallIconEnum.MiningFrigateIcon:
            return (
                <svg
                    width="16"
                    height="12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M12.268 0h-8.52L0 3.61v8.364h16V3.592L12.268 0Zm1.063 8.954H2.7V5.033l2.057-1.987h6.516l2.058 1.987v3.921Z"
                        fill={color}
                    />
                </svg>
            )
        case SmallIconEnum.MiningBargeIcon:
            return (
                <svg
                    width="14"
                    height="10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M11.312 0H2.688L0 2.33V10h14V2.33L11.312 0Zm.763 8.035H1.925V3.242l1.476-1.277h7.209l1.475 1.277-.01 4.793Z"
                        fill={color}
                    />
                </svg>
            )
        case SmallIconEnum.IndustrialIcon:
            return (
                <svg
                    width="14"
                    height="12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clipPath="url(#a)" fill={color}>
                        <path d="M.022 12H14v-1.828H.022V12ZM11.365 0H2.64L0 2.167v7.135h14.01V2.167L11.366 0Zm.749 7.474H1.875V3.016l1.45-1.188h7.323l1.45 1.188.016 4.458Z" />
                    </g>
                </svg>
            )
        case SmallIconEnum.CapitalIndustrialIcon:
            return (
                <svg
                    width="16"
                    height="13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M16 2.14 13.386 0H2.614L0 2.14v10.865l4.124-3.724h8.003L16 12.789V2.14Zm-3.201 5.335H3.44l-1.568 1.43V2.979l1.435-1.173h9.384l1.435 1.173v5.7L12.826 7.48l-.027-.005Z"
                        fill={color}
                    />
                </svg>
            )
        case SmallIconEnum.FreighterIcon:
            return (
                <svg
                    width="14"
                    height="17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clipPath="url(#a)" fill={color}>
                        <path d="M13.995 2.104 11.708 0h-9.42L0 2.104v10.679l3.609-3.661h7.002l3.384 3.448V2.104Zm-2.8 5.243H3.01L1.639 8.753V2.928l1.255-1.153h8.212l1.255 1.153V8.53l-1.12-1.178-.047-.005Z" />
                        <path d="M9.971 10.447H4.024L.808 13.723 4.024 17h5.947l3.217-3.277-3.217-3.276Zm-.597 4.783H4.622l-1.485-1.517 1.485-1.517h4.752l1.484 1.517-1.484 1.517Z" />
                    </g>
                </svg>
            )
        case SmallIconEnum.ExplorerIcon:
            return (
                <svg
                    width="16"
                    height="14"
                    viewBox="0 0 16 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M11.9183 6.93732C11.918 6.40003 12.1306 5.88356 12.5115 5.49669C12.8924 5.10982 13.4118 4.88273 13.9603 4.86326C13.438 3.26844 12.349 1.90977 10.8909 1.03382C9.43271 0.157879 7.70206 -0.177278 6.01303 0.089188C4.324 0.355654 2.78853 1.20608 1.68532 2.48612C0.582112 3.76615 -0.0157238 5.39095 0.000314508 7.06562C0.0163528 8.74029 0.645201 10.3538 1.77273 11.6134C2.90027 12.873 4.45175 13.6951 6.14558 13.9305C7.83942 14.1659 9.56335 13.799 11.0045 12.8965C12.4456 11.9939 13.5084 10.6155 14 9.01139C13.4445 9.00188 12.9151 8.77916 12.5257 8.39123C12.1364 8.00329 11.9182 7.48117 11.9183 6.93732Z"
                        fill={color}
                    />
                    <path
                        d="M14.07 5H14C14.4038 6.29859 14.4164 7.6938 14.0362 9H14.07C14.5818 9 15.0728 8.78929 15.4347 8.41422C15.7967 8.03914 16 7.53043 16 7C16 6.46957 15.7967 5.96086 15.4347 5.58578C15.0728 5.21071 14.5818 5 14.07 5V5Z"
                        fill={color}
                    />
                </svg>
            )
        case SmallIconEnum.IndustrialistIcon:
            return (
                <svg
                    width="17"
                    height="15"
                    viewBox="0 0 17 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M12.7478 0H4.25224L0 7.50455L4.25224 15H12.7478L17 7.49545L12.7478 0ZM8.49555 10.5549C7.90349 10.5549 7.32472 10.376 6.83243 10.0408C6.34015 9.70563 5.95646 9.22924 5.72989 8.67186C5.50332 8.11448 5.44404 7.50117 5.55955 6.90946C5.67505 6.31775 5.96015 5.77423 6.3788 5.34764C6.79745 4.92104 7.33084 4.63052 7.91153 4.51283C8.49222 4.39513 9.09413 4.45554 9.64112 4.68641C10.1881 4.91728 10.6556 5.30825 10.9846 5.80987C11.3135 6.3115 11.4891 6.90125 11.4891 7.50455C11.4899 8.31222 11.1759 9.08717 10.6163 9.65913C10.0567 10.2311 9.29709 10.5533 8.50447 10.5549H8.49555Z"
                        fill={color}
                    />
                </svg>
            )
        case SmallIconEnum.EnforcerIcon:
            return (
                <svg
                    width="14"
                    height="18"
                    viewBox="0 0 14 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M7 0L0 1.26643V4.16893V11.9121L7 18L14 11.9121V4.16893V1.26643L7 0Z"
                        fill={color}
                    />
                </svg>
            )
        case SmallIconEnum.SoldierOfFortuneIcon:
            return (
                <svg
                    width="14"
                    height="17"
                    viewBox="0 0 14 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M14 7.2841C13.9996 6.18911 13.7621 5.10829 13.3053 4.12197C12.8484 3.13566 12.1839 2.26921 11.3611 1.58701C10.5383 0.904817 9.57842 0.424423 8.55275 0.181532C7.52708 -0.0613582 6.46201 -0.060496 5.43671 0.184048C4.4114 0.428592 3.45222 0.910529 2.63045 1.59405C1.80868 2.27757 1.14544 3.14509 0.690042 4.13214C0.234647 5.11919 -0.00121601 6.20039 4.71436e-06 7.29538C0.00122544 8.39037 0.239497 9.471 0.697092 10.4569L0.291671 12.4457C1.45199 12.4457 2.56478 12.9255 3.38525 13.7796C4.20572 14.6337 4.66667 15.7921 4.66667 17H9.33333C9.33333 15.7921 9.79428 14.6337 10.6147 13.7796C11.4352 12.9255 12.548 12.4457 13.7083 12.4457L13.3029 10.4569C13.7631 9.46792 14.0014 8.38302 14 7.2841ZM3.79167 12.142C3.33018 12.142 2.87905 11.9996 2.49533 11.7327C2.11162 11.4658 1.81257 11.0864 1.63596 10.6426C1.45936 10.1988 1.41313 9.71038 1.50316 9.23921C1.59319 8.76803 1.81543 8.33522 2.14175 7.99553C2.46807 7.65583 2.88385 7.42449 3.33647 7.33077C3.7891 7.23705 4.25825 7.28515 4.68461 7.46899C5.11097 7.65284 5.47537 7.96416 5.73175 8.36361C5.98814 8.76305 6.125 9.23267 6.125 9.71307C6.125 10.3573 5.87917 10.9751 5.44158 11.4306C5.004 11.8861 4.41051 12.142 3.79167 12.142ZM6.125 13.1106L6.70833 11.5925H7.29167L7.875 13.1106H6.125ZM10.2083 12.142C9.74684 12.142 9.29571 11.9996 8.91199 11.7327C8.52828 11.4658 8.22923 11.0864 8.05263 10.6426C7.87602 10.1988 7.82979 9.71038 7.91982 9.23921C8.00986 8.76803 8.23209 8.33522 8.55841 7.99553C8.88474 7.65583 9.30051 7.42449 9.75313 7.33077C10.2058 7.23705 10.6749 7.28515 11.1013 7.46899C11.5276 7.65284 11.892 7.96416 12.1484 8.36361C12.4048 8.76305 12.5417 9.23267 12.5417 9.71307C12.5417 10.3573 12.2958 10.9751 11.8582 11.4306C11.4207 11.8861 10.8272 12.142 10.2083 12.142Z"
                        fill={color}
                    />
                </svg>
            )
        default:
            return <></>
    }
}

SmallIcons.defaultProps = {
    color: IconColorEnum.GrayColor,
}
